module.exports = __webpack_public_path__ + "img/6.ec369a2a.jpg";